const divCardsTimeLine = {
  action: 'Action',
  item: 'Related Item',
  service: 'Service',
  accountable: 'Accountables'
};

export default divCardsTimeLine;
